export type UiNumberFormat = {
	decimalSeparator: string;
	groupSeparator: string;
	decimalsQuantity: number;
	currencySymbol: string;
};

const DEFAULT_UI_NUMBER_FORMAT: UiNumberFormat = {
	decimalSeparator: '.',
	groupSeparator: ',',
	decimalsQuantity: 2,
	currencySymbol: '$'
};

let provider: () => UiNumberFormat = () => DEFAULT_UI_NUMBER_FORMAT;

export function setUiNumberFormatProvider(fn: () => UiNumberFormat): void {
	provider = fn;
}

export function getUiNumberFormat(): UiNumberFormat {
	return provider();
}
